<template>
  <form method="post" @submit.prevent="send">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          {{ $t('attributes.area_management') }}
        </p>
      </header>
      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <form-group
            horizontal
            name="emp_code"
            :label="$t('attributes.employee_code')"
          >
            <b-input
              v-model="form.emp_code"
              name="emp_code"
              :placeholder="
                $t('message.please_input') + $t('attributes.employee_code')
              "
              disabled
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            horizontal
            name="name"
            :label="$t('attributes.employee_name')"
          >
            <b-input
              v-model="form.name"
              name="name"
              :placeholder="
                $t('message.please_input') + $t('attributes.employee_name')
              "
              disabled
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            horizontal
            name="area_code_perm"
            :label="$t('attributes.area')"
          >
            <div
              class="columns is-multiline is-mobile"
              style="min-height: 200px;"
            >
              <b-checkbox
                v-for="area in areaList"
                v-model="form.area_code_perm"
                :value="area.code"
                :native-value="area.code"
                :key="area.code"
                class="column is-6 is-marginless"
              >
                {{ `[${area.code}] ${area.name}` }}
              </b-checkbox>
            </div>
          </form-group>
        </form-wrapper>
      </section>
      <footer class="modal-card-foot">
        <b-button @click="$parent.close()">
          {{ $t('attributes.close') }}
        </b-button>
        <b-button type="is-primary" :loading="sending" native-type="submit">
          {{ $t('attributes.modify') }}
        </b-button>
      </footer>

      <b-loading
        :is-full-page="false"
        :active="sending || loadingAreas"
      ></b-loading>
    </div>
  </form>
</template>

<script>
import { AREA_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'EmployeeAreaForm',
  props: {
    sending: Boolean,
    employee: {
      type: Object,
      required: true
    }
  },
  data() {
    const area_code_perm = this.employee.area_code_perm
      ? this.employee.area_code_perm.split('')
      : []

    return {
      loadingAreas: false,
      areaList: [],

      form: {
        emp_code: this.employee.emp_code,
        name: this.employee.name,
        area_code_perm: area_code_perm
      }
    }
  },
  validations: {
    form: {
      area_code_perm: {}
    }
  },
  mounted() {
    this.loadAreas()
  },
  methods: {
    async loadAreas() {
      try {
        this.loadingAreas = true
        const res = await this.axios.get(`${AREA_API}/list`)
        const areas = res.data.data
        this.areaList = areas.sort(a => a.sort)
      } catch (e) {
        this.areaList = []

        notifyService.fetch_error('area', e)
      } finally {
        this.loadingAreas = false
      }
    },
    async send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }
      this.$emit('onSend', this.form)
    }
  }
}
</script>
